import { useEffect, useState } from 'react'
import type { UseQueryResult } from 'react-query'
import { useGetPaymentMethodsAndProviders } from '@yuno/dashboard-api-mfe'
import { Payment } from '@yuno/types'

const useImages = () => {
  const [paymentMethods, setPaymentMethods] = useState({})
  const [providers, setProviders] = useState({})
  const { data }: UseQueryResult<Payment.PaymentMethodsAndProviders, unknown> =
    useGetPaymentMethodsAndProviders()

  useEffect(() => {
    if (data) {
      const payment_methods = {}
      data?.payment_methods.forEach((paymentMethod) => {
        payment_methods[paymentMethod?.id] = paymentMethod
      })
      const _providers = {}
      data?.providers.forEach((provider) => {
        _providers[provider?.id] = provider
      })
      setPaymentMethods(payment_methods)
      setProviders(_providers)
    }
  }, [data])

  return {
    paymentMethods,
    providers,
  }
}

export { useImages }
